import React from 'react';
import { shape, string } from 'prop-types';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { CardContent, Image } from '@thd-olt-component-react/core-ui';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

const TilePropTypes = {
  title: string,
  description: string,
  link: string,
  image: shape({
    description: string,
    url: string,
    title: string,
  }),
  id: string,
};

const TileDefaultProps = {
  title: undefined,
  description: undefined,
  link: undefined,
  image: {},
  id: undefined,
};

export function CustomRenderedTile({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  function Tile({
    title, description, link, image, id
  }) {
    const { url, description: imageDescription, title: imageTitle } = image;

    return (
      <div key={id}>
        <a href={link}>
          <Hydrator
            id={`${id}-tile-php-hydrator`}
            className={styles('u-height-100')}
            scrollBuffer={SCROLL_BUFFER}
            delay={HOMEPAGE_DELAY_STANDARD}
            placeholder={PLACEHOLDER}
          >
            <CardContent className="card-content">
              <div className="image-container">
                <Image
                  className="card-image"
                  src={url}
                  alt={imageDescription || imageTitle}
                />
              </div>
              <hr className={styles('component__hr')} />
              <div>
                <h3 className={styles('component__item--header')}>{title}</h3>
                <p className={styles('component__item--subheader')}>
                  {description}
                </p>
              </div>
            </CardContent>
          </Hydrator>
        </a>
      </div>
    );
  }

  Tile.propTypes = TilePropTypes;
  Tile.defaultProps = TileDefaultProps;

  return Tile;
}
